import { render, staticRenderFns } from "./manageGoods1备份.vue?vue&type=template&id=1d6d245e&scoped=true&"
import script from "./manageGoods1备份.vue?vue&type=script&lang=js&"
export * from "./manageGoods1备份.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1备份.vue?vue&type=style&index=0&id=1d6d245e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d245e",
  null
  
)

export default component.exports